import {
    Box,
    Typography
} from "@mui/material";

import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { ImageSource } from "../../API";
import { grey } from "@mui/material/colors";

type ImageSourceOverlayProps = {
    source: ImageSource;
};
export const ImageSourceOverlay = ({ source }: ImageSourceOverlayProps) => {
    const isTakenOnTheSpot = source === ImageSource.CAMERA;

    return (
        <Box
            bgcolor={isTakenOnTheSpot ? "success.light" : grey[500]}
            color="white"
            sx={{ opacity: 0.8 }}
            px={0.5}
            py={0.25}
            display="flex"
            alignItems="center"
            gap={0.5}
            zIndex={theme => theme.zIndex.tooltip}
        >
            {isTakenOnTheSpot ? <CameraAltOutlinedIcon fontSize="small" /> : <FileUploadOutlinedIcon fontSize="small" />}
            <Typography
                variant="caption"
                sx={{
                    "@container (max-width: 270px)": {
                        display: "none"
                    }
                }}
            >
                {isTakenOnTheSpot ? "Taken on site" : "Library Upload"}
            </Typography>
        </Box>
    );
};
